import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        filterOverview: '='
    },
    template: `
        <ul class="metablock">
            <li ng-repeat="(key, label) in vm.filterOverview.labels" ng-if="vm.filterOverview.values[key]">
                <div class="label">{{ label}}</div>
                <div ng-attr-title="{{ vm.filterOverview.fullText[key] }}" class="value">
                    {{ vm.filterOverview.values[key] }}
                    <br/>
                    <a ng-if="vm.filterOverview.fullText[key] && vm.filterOverview.values[key].endsWith('...')"
                       ng-click="vm.showAll(vm.filterOverview.fullText[key], label)">
                        {{ 'filter.View all' | translate }}
                    </a>
                </div>
            </li>
        </ul>
    `
})
export default class {
    constructor (ModalService) {
        this.ModalService = ModalService;
    }

    showAll (body, header) {
        this.ModalService.open({
            template: '<modals-filter-overview header="vm.header" body="vm.body" uib-modal-instance="vm.$uibModalInstance" class="wrapper"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.header = header;
                this.body = body;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/filter/overview/index.js